/* eslint-disable no-console */
export default ( {
	app,
	authService,
	loadedSlices,
	layouts,
} ) => {
	const lazyLoadSliceComponent = ( { component, } ) => {
		return () => {
			if ( !loadedSlices.has( "@teaming/slice-gokr" ) ) {
				return import( "@teaming/slice-gokr" ).then( async ( { gokrSlice, } ) => {
					gokrSlice();
					loadedSlices.set( "@teaming/slice-gokr", true );
					return app.component( component );
				} );
			}
			return Promise.resolve( app.component( component ) );
		};
	};

	const routes = [
		{
			path: "/goals",
			name: "MY_GOALS",
			component: layouts.RouterViewLayout,
			props: true,
			children: [
				{
					path: "",
					name: "MY_GOALS/MY_GOALS_LIST",
					meta: { title: "slice-gokr.routes.goals", },
					component: lazyLoadSliceComponent( { component: "MyGoalsHOC", } ),
					props: true,
				},
				{
					path: "new",
					name: "MY_GOALS/MY_NEW_GOAL",
					meta: { title: "slice-gokr.routes.newGoal", bodyClass: "teaming-gokr--page", },
					component: lazyLoadSliceComponent( { component: "MyNewGoalHOC", } ),
					props: true,
				},
				{
					path: ":goalId",
					name: "MY_GOALS/MY_GOAL",
					meta: { title: "slice-gokr.routes.updateGoal", bodyClass: "teaming-gokr--page", },
					component: lazyLoadSliceComponent( { component: "MyGoalHOC", } ),
					props: true,
				},
				{
					path: ":goalId/key-result/new",
					name: "MY_GOALS/MY_NEW_KEY_RESULT",
					meta: { title: "slice-gokr.routes.newKeyResult", },
					component: lazyLoadSliceComponent( { component: "MyNewKeyResultHOC", } ),
					props: true,
				},
				{
					path: ":goalId/key-result/:keyResultId",
					name: "MY_GOALS/MY_KEY_RESULT",
					meta: { title: "slice-gokr.routes.updateKeyResult", },
					component: lazyLoadSliceComponent( { component: "MyKeyResultHOC", } ),
					props: true,
				},
			],
			beforeEnter: authService.authGuard,
		},
	];

	return routes;
};
